import type { FaireProductEntity } from "../../entity_types/product";

export const p_92wqjyanra: FaireProductEntity = {
  token: "p_92wqjyanra",
  type: "product",
  name: "Bakasco Yuzu & Kaki Vinegar Hot Pepper Sauce - 2oz (60ml)",
  brandToken: "b_3583ydpmlg",
  brandName: "M5 Corporation",
  imageUrl:
    "https://cdn.faire.com/fastly/d3ed14da79c41c2b209432d8cd9db07f0e8e42ec8330b09a3309412ceacf3675.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e94ec86cd00a589e3886ecf70ed8777b301433990bb384afc4c762af75337b26.png",
    "https://cdn.faire.com/fastly/975af2d45e5f65f9d8de430a188a6151cf30b0f87758c5d3e7bddf7c486125b8.jpeg",
    "https://cdn.faire.com/fastly/fd85f0353c8f187f5c84b42cb3d2eacd2cdc15207f78103dd6a41c3d0da5865e.png",
    "https://cdn.faire.com/fastly/59b7d23f86a7f4b831b9d9680b2fe04175bafc42e26cdd1c3d608f62ddba0a0a.jpeg",
    "https://cdn.faire.com/fastly/1b7d6b164140adc63e0b0273e507dec2141045390a402e2c7be24d5daf4bd1aa.png",
    "https://cdn.faire.com/fastly/321370fa1988aeabb2a428b71c6c41f74acee0711fea2fe50f17e89c523d5172.jpeg",
    "https://cdn.faire.com/fastly/ed787299dcb046b024c7178a15176c3e22666b18812559eddf6eb0e07f363afd.png",
    "https://cdn.faire.com/fastly/d586973580a6b469aaa31a48a56b2a424db1ded0240f9f796f4b5342326d7521.png",
    "https://cdn.faire.com/fastly/91c658e3e088ce98f3aa206951c607eb07cdc3ad36c303862b9e3930dc6904ec.png",
  ],
  priceDollars: 7.5,
  description:
    "Bakasco sauce is an innovative spicy condiment that combines the heat of chili peppers with the tangy freshness of yuzu, a Japanese citrus fruit.\n\nPerfect for adding a spicy kick to your sushi, maki, or tempura, Bakasco also pairs beautifully with charcuterie boards or aged cheeses. It’s ideal for marinating meats or fish before grilling or for flavoring barbecue sauces. Its unique taste also makes it a great choice for spicing up dressings or mayonnaise for sandwiches and burgers.\n\nRecipe Ideas with Bakasco Sauce\n\n    Grilled Chicken with Bakasco: Mix the sauce with yogurt, garlic, and honey to create a marinade for chicken. Grill it and serve with a fresh salad;\n    Seafood Salad: Incorporate Bakasco sauce into a seafood salad with shrimp, calamari, and mussels, tossed with olive oil and lemon juice;\n    Bakasco Tacos: Drizzle Bakasco sauce over fish or chicken tacos before topping with fresh vegetables, cilantro, and sour cream.",
  tags: [],
  msrpDollars: 13.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:51.722Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
